export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de contenedores"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reportes de calidad"])},
          "show_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ver"])}
        }
      },
      "en": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back to list of containers"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quality reports"])},
          "show_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Show"])}
        }
      }
    }
  })
}